export default "__VITE_ASSET__C$GiMo9v__"